import { Route } from "found";


import { CustomerLogoQuery } from "../authentication/CustomerLogoQuery";
import LoginPage from "../authentication/LoginPage";

import HomeContent from "./HomeContent";
import { HomeContentQuery } from "./HomeContentQuery";

import { PageTitleWrapper } from "pstat-anywhere/utils/pageWrappers";

const routes = (
  <Route
    getComponent={({ context }) => {
      if (context.viewer) {
        return props => (
          <PageTitleWrapper titleKey="home.homeContent.documentTitle">
            <HomeContent {...props} />
          </PageTitleWrapper>
        );
      } else {
        return props => (
          <PageTitleWrapper titleKey="loginPage.documentTitle">
            <LoginPage {...props} />
          </PageTitleWrapper>
        );
      }
    }}
    getQuery={({ context }) => {
      if (context.viewer) {
        return HomeContentQuery;
      } else {
        return CustomerLogoQuery;
      }
    }}
    data={{ routeName: "home" }}
  />
);

export default routes;
